import {State} from 'application/store';
import StoreError from 'application/store/utility/errors/StoreError';
import getProductInfo from 'application/store/admin/actions/getProductInfo';
import setAlert from 'application/store/alerts/actions/setAlert';
import {deleteProductDeptAPI} from 'application/api';
import {isDebugging} from 'application/utility';
import {SetState, GetState} from 'zustand';

export const deleteProductDept = (set: SetState<State>, get: GetState<State>) =>
	async (listId: number, productId: number) => {
    const productInStore = get().productInfo;

    if (!productInStore) throw new StoreError(
      productInStore,
      'There was an issue retrieving the product, please try again later.',
      {
        log: isDebugging,
        display: true
      }
    );

		const res = await deleteProductDeptAPI({listId: listId, productId: productId});

		if (res !== null) setAlert(set, get)({
			status: 'success',
			header: 'Success',
			text: 'Successfully deleted department'
		});

		getProductInfo(set, get)(productInStore.itemId);
	};

export default deleteProductDept;